// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__E7es-","label":"SetPasswdForm_label__2BKni"};